<main>

  <div class="circle">
    <div class="conteudo">
      <img src="../../../assets/images/imagem-login.png">
    </div>
  </div>

  <div class="content">

    <div class="img-logo">
      <img src="../../../assets/images/logo.png" alt="">
    </div>

    <form [formGroup]="formLogin" (submit)="entrar()" (keydown.enter)="entrar()" class="form">
      <!--            <h1 class="title-desk"><strong>Hey, </strong>Bem Vindo!</h1>-->
      <h2>Login</h2>
      <h5>Informe seu e-mail e senha para entrar:</h5>
      <tgt-input-icon id="login-input" [error]="campoObrigatorio" [border]="true" [error]="campoObrigatorio"
                      [control]="this.formLogin.controls.identifier" placeholder="E-mail corporativo" [type]="'email'"
                      [iconPosition]="'right'" [icon]="'email'"></tgt-input-icon>
      <tgt-input-icon id="password-input" [error]="campoObrigatorio" [border]="true" [error]="campoObrigatorio"
                      [control]="this.formLogin.controls.password" placeholder="Senha" [type]="'password'" icon="lock"
                      [iconPosition]="'right'"></tgt-input-icon>
      <div class="forgot">
        <span><a href="/recuperar-senha">Esqueci minha senha?</a></span>
      </div>
      <tgt-button id="login-button" type="button" [disabled]="!formLogin.valid" [color]="'primary'" size="small"
                  iconPosition="right"
                  (click)="entrar()">Entrar
      </tgt-button>
    </form>

    <div class="privacy-link" style="margin-top: 1rem; text-align: center;cursor: pointer">
      <a style="color: #000;" (click)="abrirTermos()">Política de Privacidade</a>
    </div>
  </div>

</main>
